export var validate = {
    email: function ValidateEmail(mail) {
        if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(mail.trim())) {
            return (true)
        } else {

            return (false)
        }
    },
    phone: function (inputtxt) {
        let num = inputtxt.replace(/ /g, "");
        //  let phoneno = /^\d{10}$/;
        let phoneno_format1 = /^[0-9]{3}[0-9]{3}[0-9]{4}$/;
        // let phoneno_format1 = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;

        if (num.match(phoneno_format1) && num > 0) { return true; }
        else {
            return false;
        }
    },
    zipCode: function (inputtxt) {
        let zipNo = /^[0-9]{5}$/;
        //let zipNo = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

        if (inputtxt.match(zipNo) && inputtxt != 0 && inputtxt >= 1) { return true; }
        else {
            return false;
        }
    },
    website: function (url) {
        var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
        if (!re.test(url)) {

            return false;
        }
        else { return true; }
    },
    name: function (inputName) {
        let validName = /[a-zA-Z][a-zA-Z ]*/;
        if (inputName && inputName.value.match(validName)) { return true; } else { return false }
    },
    onlyNum: function (inputtxt) {
        var number = /^[0-9]{1,45}$/;
        if (inputtxt.match(number)) { return true; } else { return false }
    },
    noSpaces: function (inputtxt) {
        var str = /[^\s]+/;
        if (inputtxt.value.match(str)) { return true; } else { return false }
    },
    notEmpty: function (val) {
        let length = val.trim().length;
        if (!length) { return false; }
        else { return true }
    },
    getUrlParam: function getParameterByName(name, url) {

        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    isValidPassword: function (password) {
        let passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})");
        return passwordRegex.test(password);

    }
}



/** WEBPACK FOOTER **
 ** ./src/validations.js
 **/